{
    "longSHA": "3bb6d802fea4ba07283f8dfb88bc23e9ff203fad",
    "shortSHA": "3bb6d80",
    "branch": "development",
    "authorName": "andrejz",
    "commitTime": "Fri Dec 19 14:22:00 2025 +0100",
    "commitMsg": "fixed FE cicd tmp",
    "totalCommitCount": "1"
}